import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import Image from '../Image';
import stylesheet from 'src/constants/stylesheet';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            psotion: 'relative',
            display: 'flex',
            flexWrap: 'wrap',
            [mediaQueries.Mobile]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
                // marginBottom: spacing.Gutter.Mobile * 2,
            },
            [mediaQueries.Tablet]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
            [mediaQueries.Laptop]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },
            [mediaQueries.Desktop]: {
                marginLeft: -spacing.Gutter.Desktop / 2,
                marginRight: -spacing.Gutter.Desktop / 2,
            },

        },
        panel: {
            boxSizing: 'border-box',
            width: `100%`,
            [mediaQueries.Mobile]: {
                // width: '50%',
                paddingLeft: spacing.Gutter.Tablet / 2,
                paddingRight: spacing.Gutter.Tablet / 2,
                marginBottom: spacing.Gutter.Mobile,
            },
            [mediaQueries.Tablet]: {
                paddingLeft: spacing.Gutter.Tablet / 2,
                paddingRight: spacing.Gutter.Tablet / 2,
                marginBottom: spacing.Gutter.Tablet,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.Gutter.Laptop / 2,
                paddingRight: spacing.Gutter.Laptop / 2,
                marginBottom: spacing.Gutter.Laptop,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.Gutter.Desktop / 2,
                paddingRight: spacing.Gutter.Desktop / 2,
                marginBottom: spacing.Gutter.Desktop,
            },
        },
        figure: {
            position: 'relative',
            height: 0,
            overflow: 'hidden',
            paddingBottom: '50%'
        },
        img: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            padding: 30,
            ...stylesheet.ObjectFitContain
        },
        link: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1
        },
        hr: {
            ...stylesheet.HR
        }
    }));

export type PanelLabelProps = PanelLabelDto;
type Props = PanelLabelProps;

const PanelLabel: FC<Props> = ({ Image: image, Link: link, ShowTopLine }) => {
    const cls = useStyles();

    const isInternal = link && link.startsWith('/');

    const sizes = '(max-width:767px) 100vw, ' + 
                    '(min-width: 768px) and (max-width: 1024) and (orientation: landscape) calc(100vw / 3), ' +
                    '(min-width: 768px) and (max-width: 1024) and (orientation: portrait) calc(100vw / 2), ' +
                    '(min-width: 1025px) 300px';

    return (
        <div className={cls.root}>
            <div
                className={cls.panel}
            >
                {ShowTopLine && <hr className={cls.hr} />}
                <div className={cls.figure}>
                    {link && isInternal && <Link to={link} className={cls.link} />}
                    {link && !isInternal && <a href={link} target='_blank' className={cls.link} />}
                    <Image pictureRef={image} sizes={sizes} className={cls.img} />
                </div>
            </div>
        </div>
    );
}

export default PanelLabel;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelLabel.tsx